import { useEffect } from "react";

const setMeta = (attr, key, content) => {
  if (!content) return;
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setLink = (rel, href) => {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

/**
 * Met à jour les balises SEO de la page (SPA React — document.title + meta).
 * useSeo({ title, description, keywords, path, image, noindex })
 */
export const useSeo = ({ title, description, keywords = "", path = "", image = "", noindex = false }) => {
  useEffect(() => {
    const origin = window.location.origin;
    const url = `${origin}${path || window.location.pathname}`;
    const fullTitle = title ? `${title} | Sama-Keur` : "Sama-Keur — Maison & Salle de bain à Dakar";

    document.title = fullTitle;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:description", description);
      setMeta("name", "twitter:description", description);
    }
    if (keywords) setMeta("name", "keywords", keywords);
    setMeta("property", "og:title", fullTitle);
    setMeta("name", "twitter:title", fullTitle);
    setMeta("property", "og:url", url);
    setMeta("property", "og:type", "website");
    setMeta("property", "og:locale", "fr_SN");
    setMeta("name", "twitter:card", "summary_large_image");
    if (image) {
      const absImage = image.startsWith("http") ? image : `${origin}${image}`;
      setMeta("property", "og:image", absImage);
      setMeta("name", "twitter:image", absImage);
    }
    setMeta("name", "robots", noindex ? "noindex, nofollow" : "index, follow");
    setLink("canonical", url);
  }, [title, description, keywords, path, image, noindex]);
};
